import { render, staticRenderFns } from "./MergeQuestionsNotification.vue?vue&type=template&id=6be3a05f&scoped=true&"
import script from "./MergeQuestionsNotification.vue?vue&type=script&lang=js&"
export * from "./MergeQuestionsNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be3a05f",
  null
  
)

export default component.exports